import { capturePageView } from "@/app/_analytics/analytics";
import { usePostHogState } from "@/app/_providers/posthog";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const useCapturePageViews = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isPostHogLoaded = usePostHogState(state => state.isLoaded);

  useEffect(() => {
    if (!pathname || !isPostHogLoaded) return;

    let url = window.origin + pathname;
    if (searchParams && searchParams.toString()) {
      url = url + `?${searchParams.toString()}`;
    }
    capturePageView(url);
  }, [pathname, searchParams, isPostHogLoaded]);
};
